export default "__VITE_ASSET__t8$bD0zM__"